var map = {
	"./icon-check.svg": "c25b",
	"./icon-email.svg": "19d0",
	"./icon-link.svg": "76f3",
	"./icon-linkedin.svg": "4c08",
	"./icon-mail.svg": "9409",
	"./icon-menu-close-light.svg": "1922",
	"./icon-menu-close.svg": "585c",
	"./icon-menu-light.svg": "6cd1",
	"./icon-menu.svg": "2d23",
	"./icon-send.svg": "b13f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f65";